import Login from './login';
import ChangePassword from './changePassword';
import AcceptInvite from './acceptInvite';
import AcceptWitnessInvite from './acceptWitnessInvite';
import ForgotPassword from './forgot';
import ResetPassword from './reset';

export { Login, ChangePassword, AcceptInvite, AcceptWitnessInvite, ForgotPassword, ResetPassword };



// WEBPACK FOOTER //
// ./src/pages/account/forms/index.js